import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../images/newlogo-small.png'
import logo2 from '../images/sb_boltware.png'
import userImage from '../images/logout.png'
import useAuth from '../context/useAuth';
import useApi from '../api/useApi';
import useLogout from '../api/useLogout';
import ChatService from '../services/ChatService';
import { Button, Popover, OverlayTrigger, Overlay } from "react-bootstrap";

const NavHeader = () => {
    const { auth } = useAuth();
    const api = useApi();
    const navigate = useNavigate();
    const logout = useLogout();
    const [isOnline, setIsOnline] = useState(navigator.onLine);

    const signOut = async () => {
        await logout();
    }

    //useEffect(() => {

    //    const handleBeforeUnload = (event) => {
    //        if (event.clientX < 0 && event.clientY < 0) {
    //            // Page is being closed, not refreshed
    //            signOut();

    //            if (event.preventDefault) {
    //                event.preventDefault();
    //            }

    //            event.returnValue = 'logging out...';
    //        }
    //    };
    
    //    window.addEventListener('beforeunload', handleBeforeUnload);

    //    return () => {
    //        window.removeEventListener('beforeunload', handleBeforeUnload);
    //    };
    //}, []);


    const handleOnConnectionEstablished = useRef(() => {

    }).current;

    const handleOnMessageReceived = useRef((message) => {

        if (message) {
            switch (message.message) {
                case 'LOG_OUT':
                    {
                        debugger
                        if (message.senderId === auth.userId)
                            logout();
                        break;
                    }
                default:
            }
        }

    }).current;

    const _chatService = ChatService({ onConnectionEstablished: handleOnConnectionEstablished, messageReceived: handleOnMessageReceived });

    const popover = (
        <Popover id="popover-basic">
            {/*<Popover.Header as="h3"></Popover.Header>*/}
            <Popover.Body>
                <div style={{color:"#000000"} }>
                <p>Licence No : {auth?.licenseNo} </p>
                <p>Mobile No : {auth?.mobileNumber}</p>
                </div>
            </Popover.Body>
        </Popover>
    );

    return (

        <div className="main-header side-header hor-header" style={{ marginBottom: '-64.3333px' }}>
            <div className="main-container container">
                <div className="main-header-left">
                    <a className="main-header-menu-icon" href="" id="mainSidebarToggle"><span></span></a>
                    <div className="hor-logo">
                        <a className="main-logo" href="/home">
                            <img src={logo2} className="header-brand-img desktop-logo " style={{ maxWidth: "50%" }} alt="logo" />
                            <img src={logo2} className="header-brand-img desktop-logo-dark" alt="logo" />
                        </a>
                    </div>
                </div>
                <div className="main-header-center">
                    {/*<div className="responsive-logo">*/}
                    {/*    <a href="/">*/}
                    {/*        <img src="./header Spruha - Bootstrap Premium HTML Dashboard Template_files/logo.png" className="mobile-logo" alt="logo" />*/}
                    {/*    </a>*/}
                    {/*    <a href="/">*/}
                    {/*        <img src="./header Spruha - Bootstrap Premium HTML Dashboard Template_files/logo-light.png" className="mobile-logo-dark" alt="logo" />*/}
                    {/*    </a>*/}
                    {/*</div>*/}
                </div>
                <div className="main-header-right">
                    <div className="d-flex justify-content-center align-item-center" style={{ cursor: 'pointer' } }>
                        <OverlayTrigger
                            key={1}
                            trigger="click"
                            placement="bottom"
                            overlay={popover}
                            rootClose={true}
                        >
                            <span className="mg-t-3 me-2 text-muted">{auth?.name}</span>
                        </OverlayTrigger>
                        <span className="main-img-user d-flex" onClick={signOut}>
                            <img alt="avatar" src={userImage} /></span>
                    </div>
                </div>
            </div>
        </div>


    );
}

export default NavHeader;